import { memo, useEffect } from 'react';
import * as FmBridgeBackend from '@Sage/fm-bridge-backend';
import { getLocalFormFragmentOverrides } from 'components/DevPopUp/localFormFragment';
import { API_URL, B2_URL, NEW_API_URL, WEB_VERSION } from 'constants/Environment';
import Context from 'managers/Context';
import { axios } from './services/axios';

const FragmentsProviderContext = ({ children }) => {
    useEffect(() => {
        if (Context.config) {
            const ctx = {
                platform: 'web',
                loginToken: Context?.config?.token,
                userData: Context?.config?.userData,
                B2_URL,
                NEW_API_URL,
                API_URL,
                webVersion: WEB_VERSION,
                xfmServer: Context?.config?.serverAssignment?.XFMServer,
                localFormFragments: getLocalFormFragmentOverrides(),
            };
            FmBridgeBackend.setContext(ctx)
                .then(() => FmBridgeBackend.setAxiosDevices(axios))
                .then(() => FmBridgeBackend.init())
                .catch(console.warn);
        }
    }, []);
    return children;
};

export default memo(FragmentsProviderContext);
